import React, { useState, useEffect } from "react";
import { MenuIcon, Horse, Truck, Car, Van } from "lucide-react";
import axios from "axios";
import { getApiUrl } from "../config/api";

export default function TopBar({ onToggleSidebar }) {
  const [user, setUser] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    fetchUserData();
  }, []);

  const fetchUserData = async () => {
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        setIsLoading(false);
        return;
      }

      const response = await axios.get(getApiUrl("/api/profile"), {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      
      setUser(response.data);
    } catch (err) {
      console.error("Error fetching user data:", err);
    } finally {
      setIsLoading(false);
    }
  };

  const getFirstName = () => {
    if (!user || !user.name) return "";
    return user.name.split(" ")[0];
  };

  return (
    <div className={`text-white px-4 py-3 flex justify-between items-center sticky top-0 z-[60] transition-all duration-200 ${
      isScrolled 
        ? 'bg-[#b07135] shadow-lg border-b border-[#b87333] backdrop-blur-sm bg-opacity-95' 
        : 'bg-[#b07135]'
    }`}>
      {/* Hamburger: only visible on mobile */}
      <button
        className="lg:hidden"
        onClick={onToggleSidebar}
        aria-label="Toggle sidebar"
      >
        <MenuIcon />
      </button>

      <div className="flex items-center space-x-4">
        <div className="flex items-center space-x-2">
          <img 
            src="/favicon.ico" 
            alt="MyTrailer Logo" 
            className="w-8 h-8"
          />
          <div className="font-bold text-lg">MyTrailer</div>
        </div>
        {!isLoading && user && (
          <div className="text-sm text-gray-300">
            Welcome, {getFirstName()}!
          </div>
        )}
      </div>


    </div>
  );
}
